<template>
    <transition name="confirm-fade">
      <div v-if="isShowConfirm" class="my-confirm" @click.stop="clickFun('clickCancel')">
        <div class="ub ub-ae">
            <img class="wxshtip" src="../assets/img/new2024/wxshtip.png" alt="">
        </div>
        <div class="wrap ub ub-ac ub-pc">
                <span>点击手机右上角，分享到微信好友或朋友圈</span>
        </div>
      </div>
      
    </transition>
  </template>
  
  <script>
  
  export default {

    data() {
      return {
        isShowConfirm: false, // 用于控制整个窗口的显示/隐藏
      };
    },
  
    methods: {
      show() {
        this.isShowConfirm = true;
      },
      hidden() {
        this.isShowConfirm = false;
      },
      clickFun(type) {
        this.hidden()
      }
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .my-confirm {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #0A0500;
    z-index: 900;
    /* 这里防止当用户长按屏幕，出现的黑色背景色块，以及 iPhone 横平时字体的缩放问题 */
    -webkit-text-size-adjust: 100%;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }
  
  /* 进入和出去的动画 */
  .confirm-fade-enter-active {
    animation: opacity 0.3s;
  }
  
  .confirm-fade-enter-active .wrap {
    animation: scale 0.3s;
  }
  
  .confirm-fade-leave-active {
    animation: outOpacity 0.2s;
  }
   /* 进来的动画 */
   @keyframes opacity {
    0% {
      opacity: 0;
    }
  
    100% {
      opacity: 1;
    }
  }
  
  @keyframes scale {
    0% {
      transform: scale(0);
    }
  
    60% {
      transform: scale(1.1);
    }
  
    100% {
      transform: scale(1);
    }
  }
  
  /* 出去的动画 */
  @keyframes outOpacity {
    0% {
      opacity: 1;
    }
  
    100% {
      opacity: 0;
    }
  }
  
  /* 包裹层容器样式 */
  .wxshtip {
    width: 100%;
  }
  .wrap {
    width: 100%;
    span {
        font-size: 0.9rem;
        color: #888;
    }
  }

  </style>